import { Environment } from '../models/environment.model';

export const environment: Environment = {
  production: false,
  API_BASE_URL:
    'https://nlsborrowerportal-backend-124917071187.us-east4.run.app/pipeline',
  API_AUTH_BASE_URL:
    'https://nlsborrowerportal-backend-124917071187.us-east4.run.app/api',
};
